import React from "react";
import styles from "./style.scss";

const SummaryBar = ({ summary, isMobile }) => (
  <div className={isMobile ? styles.summaryMobile : styles.summary}>
    <span>
      {summary.map((info: any, index: any) => (
        <span // eslint-disable-next-line
          key={index}
          className={styles.info}
        >
          <span
            className={isMobile ? styles.valueMobile : styles.value}
            title={info}
          >
            {info}
          </span>
          {index < summary.length - 1 && <span className={styles.dot} />}
        </span>
      ))}
    </span>
  </div>
);

export default SummaryBar;



// WEBPACK FOOTER //
// ./src/components/AdCard/SummaryBar/index.tsx